// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","324":"component---src-templates-portfolio-item-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"f4b1c91da39c443dbdf5","324":"264b99c22ab47033e4ae","453":"794dd46ed3fe38359718","522":"d65956d508c2d99ee9e9"}[chunkId] + ".js";
};